import { apiClient } from "@/v2/utils/apiClient";

export const oktaData = localStorage && JSON.parse(localStorage.getItem("okta-token-storage"));

/**
 * Restclient instance
 * with token, baseURL and timeout
 */
const restclient = apiClient;

// restclient.interceptors.response.use(
//   response => response,
//   err => {
//     if (err.response?.status === 401) {
//       // window.location.reload();
//       // alert("HERE");
//     }

//     // throw err;
//   },
// );

export default restclient;
